import React from 'react';
import {
  Typography,
  TableContainer,
  Paper,
  Table,
  TableBody,
  TableRow,
  TableCell,
  useTheme,
  Tooltip,
} from '@mui/material';
import { Profile } from '@par/shared/types/player';

type PropTypes = {
  viewProfile: Profile;
};

export const Ratings = ({ viewProfile }: PropTypes) => {
  const {
    rankedRating,
    rankedMatchWins,
    rankedMatchLosses,
    rankedMatchTies,
    rankedSitAndGoGamesPlayed,
  } = viewProfile;

  const last14Days = new Date(new Date().getTime() - 14 * 24 * 60 * 60 * 1000);

  const totalRankedGamesPlayed =
    (rankedMatchWins || 0) +
    (rankedMatchLosses || 0) +
    (rankedMatchTies || 0) +
    (rankedSitAndGoGamesPlayed || 0);

  const theme = useTheme();
  return (
    <>
      <Typography
        variant="h5"
        sx={{
          textShadow:
            theme.palette.mode === 'dark'
              ? `0 0 0px ${theme.palette.secondary.main}, 0 0 0px ${theme.palette.secondary.main}, 0px 0px 16px ${theme.palette.secondary.main}`
              : 'none',
        }}
      >
        Ranked
      </Typography>
      {rankedRating === -1 ? (
        <Typography variant="caption" mt={2}>
          * {10 - totalRankedGamesPlayed} calibration games remaining
        </Typography>
      ) : null}
      <TableContainer component={Paper} sx={{ marginTop: 2 }}>
        <Table size="small" aria-label="ratings table">
          <TableBody>
            <TableRow>
              <TableCell
                width={'50%'}
                sx={{ color: theme.palette.ranked.main }}
              >
                MMR
              </TableCell>
              <TableCell
                sx={{ textAlign: 'right', color: theme.palette.ranked.main }}
              >
                {rankedRating === -1 ? `calibrating` : rankedRating || 'N/A'}
                {viewProfile.lastRankedGamePlayedAt < last14Days.getTime()
                  ? ' (inactive)'
                  : null}
              </TableCell>
            </TableRow>
            <TableRow>
              <Tooltip placement="top" title="Wins-Losses-Draws">
                <TableCell width={'50%'}>1v1 W-L-D</TableCell>
              </Tooltip>
              <TableCell sx={{ textAlign: 'right' }}>
                {rankedMatchWins || 0}-{rankedMatchLosses || 0}-
                {rankedMatchTies || 0}
              </TableCell>
            </TableRow>
            <TableRow
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell width={'50%'}>SnG Games Played</TableCell>
              <TableCell sx={{ textAlign: 'right' }}>
                {rankedSitAndGoGamesPlayed || 0}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};
